module.exports = __webpack_public_path__ + "media/images/img-placeholder-ppt-23b06bc5ed75b8bf1ac9aff059a01d5b.jpg";